import { bannerBox } from '../../../components/BannerBox/tokens/bluestone/GO';
import { deprecatedButton } from '../../../deprecated/Button/tokens/bluestone/GO';
import type { ComponentTokens } from '../types';
import { baseComponents } from './base';

export const components: ComponentTokens = {
  ...baseComponents,
  bannerBox,
  deprecatedButton,
};
